import { ShadLineChart } from "../ShadLineChart";
import { useState, useMemo } from "react";
import { occupancyDayKey } from "./occupancyDay";

const chartConfig = {
    occupancy: { label: "תפוסה", color: "#60A3D9" }
};

/** Keep a real Instant (ISO with Z) so axis/tooltip can format in Asia/Jerusalem. */
function toChartDate(value) {
    const d = new Date(value);
    return isNaN(d.getTime()) ? "" : d.toISOString();
}

const AtarimOccupancyLinechart = ({ occupancyLineDataByDuration }) => {
    const [timeRange, setTimeRange] = useState("24h");

    const filteredOccupancyData = useMemo(() => {
        if (!occupancyLineDataByDuration || occupancyLineDataByDuration.length === 0) return [];
        const referenceDate = new Date(occupancyLineDataByDuration[occupancyLineDataByDuration.length - 1]._id);

        const hoursToSubtract = {
            "8h": 8,
            "24h": 24,
            "48h": 48,
            "3d": 72,
            "1w": 168,
        }[timeRange] || 168;

        const startDate = new Date(referenceDate.getTime() - hoursToSubtract * 60 * 60 * 1000);

        return occupancyLineDataByDuration.filter((item) => new Date(item._id) >= startDate);
    }, [timeRange, occupancyLineDataByDuration]);

    const filterDayOptions = [
        {
            value: "8h",
            filterDayOptionComponent: (
                <>
                    <div>שעות אחרונות</div>
                    <div>8</div>
                </>
            )
        },
        {
            value: "24h",
            filterDayOptionComponent: (
                <>
                    <div>שעות אחרונות</div>
                    <div>24</div>
                </>
            )
        },
        {
            value: "48h",
            filterDayOptionComponent: (
                <>
                    <div>שעות אחרונות</div>
                    <div>48</div>
                </>
            )
        },
        {
            value: "3d",
            filterDayOptionComponent: (
                <>
                    <div>ימים אחרונים</div>
                    <div>3</div>
                </>
            )
        },
        {
            value: "1w",
            filterDayOptionComponent: (
                <>
                    <div>שבוע חולף</div>
                </>
            )
        },
    ];

    const filteredDataOccupancy = useMemo(() => {
        let currentDay = null;
        let cum = 0;
        return filteredOccupancyData.map((fd) => {
            const raw = fd._id || fd.date;
            // Plaza day resets at 04:00 Israel (not calendar midnight).
            const dayKey = occupancyDayKey(raw);
            if (dayKey !== currentDay) {
                currentDay = dayKey;
                cum = 0;
            }
            const net = fd.occupancy !== undefined ? fd.occupancy : (fd.entering - fd.leaving) || 0;
            cum = Math.max(0, cum + net);
            return {
                occupancy: Math.max(0, cum),
                date: toChartDate(raw),
            };
        });
    }, [filteredOccupancyData]);

    return (
        <ShadLineChart
            data={occupancyLineDataByDuration}
            deviceNames={[]}
            lineDeviceName="תפוסת מתחם התחנה"
            timeRange={timeRange}
            setTimeRange={setTimeRange}
            filterDayOptions={filterDayOptions}
            filteredData={filteredDataOccupancy}
            chartDescription="תפוסה מצטברת לאורך היממה (איפוס יומי ב-04:00 שעון ישראל)"
            chartConfig={chartConfig}
            chartContainerStyle={"aspect-auto h-[303px] w-full"}
        />
    );
};

export default AtarimOccupancyLinechart;
